<script setup>
import ForbiddenWordDj from '../kijk_live_qmusic_nl_default/shared/ForbiddenWordDj.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const title = props.item?.properties?.typeOfWall === 'fame' ? 'Wall of fame' : 'Wall of shame'

let alignment = '6tv:col-start-3 6tv:col-end-5 5tv:col-start-3 5tv:col-end-4'
switch (props.item?.properties?.align) {
  case 'left':
    alignment = 'col-start-1 col-end-3'
    break
  case 'right':
    alignment = '6tv:col-start-5 6tv:col-end-7 5tv:col-start-4 5tv:col-end-6'
    break
  default:
    break
}

const titleRef = ref(null)
const djTimelines = []

onMounted(() => {
  const timeline = gsapTimeline({ name: 'ForbiddenWordWall' })

  if (titleRef.value) {
    timeline.from(titleRef.value, { opacity: 0, x: '-100%', duration: 0.8, ease: 'power2.out' })
  }
  djTimelines.forEach((djTimeline) => {
    timeline.add(djTimeline, '<0.2')
  })
})
</script>

<template>
  <div class="grid 6tv:grid-cols-6 5tv:grid-cols-5 grid-cols-1 gap-0 w-full h-full z-10 q-corner:h-2/3 top-1/3 q-corner:pt-64">
    <div class="flex items-center justify-center q-corner:items-start q-corner:justify-start h-full" :class="alignment">
      <div
        v-if="Object.entries(item?.enrichment?.wall).length > 0"
        ref="titleRef"
        class="font-cervo text-white text-blue font-bold tracking-[-3px] text-[10em] q-corner:text-[15em] whitespace-nowrap text-right [writing-mode:vertical-lr] rotate-180 origin-center"
      >
        {{ title }}
      </div>
      <div class="flex flex-1 gap-4 q-corner:gap-32 flex-col 5tv:max-h-[90vh] items-center align-middle justify-around w-full q-corner:mr-16">
        <div v-for="[position, dj] in Object.entries(item?.enrichment?.wall)" :key="`${position}-${dj.name}`" class="flex flex-col w-full h-100 font-cervo ml-auto">
          <ForbiddenWordDj
            containerClasses="text-[6em] 5tv:text-[7em] 6tv:text-[8em] q-corner:text-[10em] h-36 5tv:h-38 6tv:h-48 q-corner:h-56"
            imageContainerClasses="-mt-60 5tv:-mt-56 6tv:-mt-64 q-corner:-mt-[16.5rem] 5tv:ml-6 q-corner:ml-20"
            imageClasses="ml-12 5tv:scale-90 6tv:scale-110 q-corner:scale-150"
            positionClasses="w-64"
            nameClasses="pl-40"
            :position="position"
            :dj="dj"
            @timeline="djTimelines[position] = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>
